import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from 'wix-ui-core/dist/es/src/hocs/Focusable';
import { generateDataAttr } from '../utils/generateDataAttr';
import { SKIN, TYPE, SIZE } from './constants';
import { st, classes } from './Badge.st.css';
import Caption from '../Text/Caption';
import { WixStyleReactContext } from '../WixStyleReactProvider/context';
var Badge = /** @class */ (function (_super) {
    __extends(Badge, _super);
    function Badge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getProps = function () {
            // that's what you pay for using HOCs...
            var _a = _this.props, focusableOnFocus = _a.focusableOnFocus, focusableOnBlur = _a.focusableOnBlur, rest = __rest(_a, ["focusableOnFocus", "focusableOnBlur"]);
            return rest;
        };
        _this._getFocusableProps = function () {
            // add focusable hooks only when badge is clickable
            var _a = _this.props, onClick = _a.onClick, focusableOnFocus = _a.focusableOnFocus, focusableOnBlur = _a.focusableOnBlur;
            return onClick
                ? {
                    onFocus: focusableOnFocus,
                    onBlur: focusableOnBlur,
                    tabIndex: 0,
                }
                : {};
        };
        return _this;
    }
    Badge.prototype.render = function () {
        var _this = this;
        var _a = this.getProps(), children = _a.children, prefixIcon = _a.prefixIcon, suffixIcon = _a.suffixIcon, onClick = _a.onClick, dataHook = _a.dataHook, className = _a.className, rest = __rest(_a, ["children", "prefixIcon", "suffixIcon", "onClick", "dataHook", "className"]);
        return (React.createElement(WixStyleReactContext.Consumer, null, function (_a) {
            var newColorsBranding = _a.newColorsBranding;
            return (React.createElement("div", __assign({ "data-hook": dataHook, onClick: onClick }, _this._getFocusableProps(), { className: st(classes.root, __assign({ clickable: !!onClick, newColorsBranding: newColorsBranding }, rest), className) }, generateDataAttr(_this.props, [
                'type',
                'skin',
                'size',
                'uppercase',
            ]), { "data-clickable": !!onClick, "data-is-inverted": rest['data-is-inverted'] }),
                prefixIcon &&
                    React.cloneElement(prefixIcon, {
                        className: classes.prefix,
                        'data-prefix-icon': true,
                    }),
                React.createElement(Caption, { className: classes.text, caption: _this.getProps().size === 'tiny' ? 'c2' : 'c1', ellipsis: true }, children),
                suffixIcon &&
                    React.cloneElement(suffixIcon, {
                        className: classes.suffix,
                        'data-suffix-icon': true,
                    })));
        }));
    };
    Badge.propTypes = {
        /** Applied as data-hook HTML attribute that can be used to create driver in testing */
        dataHook: PropTypes.string,
        /** A css class to be applied to the component's root element */
        className: PropTypes.string,
        /** variation of the component structure */
        type: PropTypes.oneOf(['solid', 'outlined', 'transparent']),
        /** color indication of the component */
        skin: PropTypes.oneOf([
            'general',
            'standard',
            'danger',
            'success',
            'neutral',
            'warning',
            'urgent',
            'neutralLight',
            'neutralStandard',
            'neutralSuccess',
            'neutralDanger',
            'premium',
            'warningLight',
        ]),
        /** component size */
        size: PropTypes.oneOf(['medium', 'small', 'tiny']),
        /** usually an icon to appear at the beginning of the text */
        prefixIcon: PropTypes.node,
        /** usually an icon to appear at the end of the text */
        suffixIcon: PropTypes.node,
        /** callback function called when badge is clicked */
        onClick: PropTypes.func,
        /** forces an uppercase letters */
        uppercase: PropTypes.bool,
        /** remove paddings from the component */
        noPadding: PropTypes.bool,
        focusableOnFocus: PropTypes.func,
        focusableOnBlur: PropTypes.func,
        /** the text to display in the badge */
        children: PropTypes.node,
    };
    Badge.displayName = 'Badge';
    Badge.defaultProps = {
        type: TYPE.solid,
        skin: SKIN.general,
        size: SIZE.medium,
        uppercase: true,
        noPadding: false,
    };
    return Badge;
}(React.PureComponent));
export default withFocusable(Badge);
//# sourceMappingURL=Badge.js.map